export const svgList = [
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/renwenjidian.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/renwenguanhuai.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/shenmeiqingqu.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/bainchenghei/lixingsiwei.svg",
    active:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/bianchengbai/lixingsiwei.svg",
    activeIndex: 3
  },
  {
    default: "https://static0.xesimg.com/platform-fe/mallwww/svg/pipanzhiyi.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/kexuehei/yongyutanjiu.svg",
    active:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/kexuebai/yongyutanjiu.svg",
    activeIndex: 5
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/lexueshanxue.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/qinyufansi.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/xinxiyishi.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/zhenaishengming.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/jianquanrenge.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/angle/ziwoguanlibai.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/shehuizeren.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/guojiarentong.svg"
  },
  {
    default:
      "https://editor.xesimg.com/tailor/resource/guojilijie-1650338737780.svg"
  },
  {
    default:
      "https://editor.xesimg.com/tailor/resource/laodongyishi-1650337583010.svg"
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/bainchenghei/wentijiejue.svg",
    active:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/bianchengbai/wentijiejue.svg",
    activeIndex: 16
  },
  {
    default:
      "https://static0.xesimg.com/platform-fe/mallwww/svg/jishuyunyong.svg"
  }
];
export const dataArr = [
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {},
    activeIndex: 3
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  },
  {
    value: 10,
    name: "",
    emphasis: {
      disabled: true
    }
  }
];

export const baseImg =
  "https://static0.xesimg.com/platform-fe/mallwww/svg/Pei.svg";
